import { createRoutine } from 'redux-saga-routines';
import { createFileRoutine } from '../../../common/routines';
//////////////////////////////////////////////////

const HEADER = 'HEADER';
const HEADER_FILE_UPLOAD_STATUS_DATA = 'HEADER_FILE_UPLOAD_STATUS_DATA';

const headerRoutine = createFileRoutine(HEADER);
const headerFileUploadStatusData = createRoutine(HEADER_FILE_UPLOAD_STATUS_DATA);

export {
  headerRoutine,
  headerFileUploadStatusData,
};
